import { createFileRoute } from '@tanstack/react-router';
import { StandaloneSetupPage } from '@/pages/standalone-setup.page';

export const Route = createFileRoute('/standalone/setup')({
  component: StandaloneSetupPage,
});
